import { useEffect } from 'react';
import { hydratePrivacyFromServer } from '../lib/privacy';

/* Privacy Mode used to live as a floating shutter button. It now lives as a toggle
   inside the app menu (More) and in Settings. This component stays mounted only to
   hydrate the saved choice from the server so masking follows the account across
   devices, and renders nothing. */
export const PrivacyEye = () => {
  useEffect(() => { hydratePrivacyFromServer(); }, []);
  return null;
};

export default PrivacyEye;
